import React from 'react';
import { useSharedPluginState } from '@atlaskit/editor-common/hooks';
import { DatasourceErrorBoundary } from '../../datasourceErrorBoundary';
import { CardContextProvider } from '../CardContextProvider';
import { DatasourceModal } from './index';
var ModalWithState = function ModalWithState(_ref) {
  var api = _ref.api,
    editorView = _ref.editorView;
  var _useSharedPluginState = useSharedPluginState(api, ['card']),
    cardState = _useSharedPluginState.cardState;
  if (!(cardState !== null && cardState !== void 0 && cardState.showDatasourceModal)) {
    return null;
  }
  return /*#__PURE__*/React.createElement(DatasourceErrorBoundary, {
    view: editorView,
    datasourceModalType: cardState === null || cardState === void 0 ? void 0 : cardState.datasourceModalType
  }, /*#__PURE__*/React.createElement(CardContextProvider, null, function (_ref2) {
    var cardContext = _ref2.cardContext;
    return /*#__PURE__*/React.createElement(DatasourceModal, {
      view: editorView,
      modalType: cardState === null || cardState === void 0 ? void 0 : cardState.datasourceModalType,
      cardContext: cardContext
    });
  }));
};
export default ModalWithState;